<template>
  <div class="container-fluid">
    <div class="row">
      <div class="opening-final text-center">
        <img src="/static/assets/img/opening/logo.png" alt="" style="width: 20%;">
        <h1>DekCom Mini Camp VI</h1>
        <h1>Final Episode</h1>
      </div>
      <div id="particles-js" @click="changePage()"></div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import "particles.js";
export default {
  name: "openingFinal",
  data() {
    return {};
  },
  mounted() {
    window.particlesJS.load(
      "particles-js",
      "/static/assets/js/particles/particles.json",
      null
    );
  },
  methods: {
    changePage() {
      firebase
        .database()
        .ref("display")
        .set({
          changeDisplay: true
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.opening-final {
  background: linear-gradient(#8e1625, #240b36);
  color: #fdd047;
  height: 100vh;
  animation-name: fadeIn;
  animation-duration: 2s;
  opacity: 1;
  //   animation-iteration-count: infinite;
  //   animation-direction: alternate;

  & > img {
    margin-top: 25vh;
    margin-bottom: 15px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

#particles-js {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/opening/openingFinal.vue